import { abyssColors } from '@/theme/colors';
import { Columns } from '@/types';
import { TableData } from '@/types/table';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const POI_COLUMNS: Columns[] = [
  {
    isSortable: true,
    visibility: true,
    key: 'poiId',
    columnName: 'POI ID',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'workpackNumber',
    columnName: 'Work Pack',
    sortKey: 'workpackNumber',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'name',
    columnName: 'Name',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'assembly',
    columnName: 'Component',
    sortKey: 'assembly.tagName',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'paintRegion',
    columnName: 'Paint Block',
    sortKey: 'templateFieldData.paint_block',
    columnIcon: {
      icon: <InfoOutlinedIcon sx={{ color: abyssColors.error[600], fontSize: '2rem' }} />,
      action: 'updatePaintRegionId',
      condition: (rows: TableData[]) =>
        rows.some((row) => 'paintRegion' in row && !row.paintRegion),
      dialogTitle: 'Paint Block Error',
      dialogContent:
        'Failed to add the Paint block to the number of POIs. Please try again by clicking the button given below.',
      tooltipText: 'Some POIs are missing the paint block and need to be added manually',
    },
  },
  {
    isSortable: true,
    visibility: true,
    key: 'parentPaintRegionId',
    columnName: 'Parent Paint Block',
    sortKey: 'parentPaintRegionId.name',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'visibility',
    columnName: 'Visibility',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'comment',
    columnName: 'Comment',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'accessibility',
    columnName: 'Accessibility',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'status',
    columnName: 'Status',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'dueDate',
    columnName: 'Due Date',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'createdAt',
    columnName: 'Creation Date',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'isVerified',
    columnName: 'Verification',
    displayConfig: {
      type: 'VERIFICATION',
    },
  },
  {
    isSortable: true,
    visibility: true,
    key: 'type',
    columnName: 'Type',
  },
  {
    isSortable: false,
    visibility: true,
    sortKey: 'templateFieldData.deck',
    key: 'deck',
    columnName: 'Deck',
  },
  {
    isSortable: true,
    visibility: true,
    sortKey: 'deckRelativeHeight',
    key: 'deckRelativeHeight',
    columnName: 'Deck Relative Height',
  },
];

export const VIEW_3D_COLUMN: Columns = {
  isSortable: false,
  visibility: true,
  key: 'view3D',
  columnName: 'View 3D',
  displayConfig: {
    type: '3DBUTTON',
  },
};
